import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './css/custom.css';
import { BrowserRouter as Router, } from "react-router-dom";

import RootPage from "./composer/pages/RootPage.jsx";

ReactDOM.render(<Router><div><RootPage parent={this}/></div></Router>, document.getElementById('root'));